import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { getAppConfig } from './AppSelector';
import { currentAccountSelector, getAccountsByLibraryId } from './AuthSelector';

export const currentLibrarySelector = state =>
  state.getIn(['entities', 'libraries', state.getIn(['library', 'id'], '').toString()], Immutable.Map());
export const currentSiteSelector = state =>
  state.getIn(['entities', 'sites', currentLibrarySelector(state).get('siteId')], Immutable.Map());
export const terminalBranchSelector = state => state.getIn(['app', 'localBranch']);

export const getPickupBranches = createSelector(
  currentLibrarySelector,
  library => {
    if (library.get('homeBranchAsPickupLocation')) {
      return Immutable.List();
    }

    return library.get('branches', Immutable.List());
  }
);

export const getActivePreferredBranches = createSelector(
  currentAccountSelector,
  getPickupBranches,
  terminalBranchSelector,
  currentLibrarySelector,
  (account, branches, localBranch, library) => {
    if (library.get('singleBranch') && branches.size === 1) {
      return Immutable.List.of(branches.first());
    }

    const indexedBranches = Immutable.Map(branches.map(branch => [branch.get('code'), branch]));
    const preferredLocations = account ? account.get('preferredLocations', Immutable.List()) : Immutable.List();
    const eligibleLocations = localBranch ? preferredLocations.unshift(localBranch) : preferredLocations;
    return eligibleLocations.map(code => indexedBranches.get(code)).filter(branch => !!branch);
  }
);

export const getLinkedLibrariesById = createSelector(
  [currentLibrarySelector, getAccountsByLibraryId],
  (library, accountsByLibraryId) =>
    library
      .get('linkableLibraries', Immutable.List())
      .filter(linkableLibrary => accountsByLibraryId.has(linkableLibrary.get('libraryId')))
      .groupBy(linkableLibrary => linkableLibrary.get('libraryId'))
      .map(libraryList => libraryList.first())
);

export const getLibraryLinkedData = createSelector(
  [currentLibrarySelector, getAppConfig],
  (library, appConfig) => {
    const cdnHost = appConfig.get(['coreAssets', 'cdnHost'], appConfig.get('baseURL'));
    const imageBaseUrl = `${cdnHost}/images/${library.get('siteId')}`;

    return Immutable.Map({
      '@context': 'http://schema.org',
      '@type': 'Library',
      name: library.get('fullName'),
      url: appConfig.get('baseURL'),
      logo: `${imageBaseUrl}/logo.png`,
      image: `${imageBaseUrl}/logo.png`
    });
  }
);
